import { render, staticRenderFns } from "./ComponentFile.vue?vue&type=template&id=bab89ca8&scoped=true&"
import script from "./ComponentFile.vue?vue&type=script&lang=js&"
export * from "./ComponentFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab89ca8",
  null
  
)

export default component.exports